var map = {
	"./$pac.svg": "73ce",
	"./0xbtc.svg": "c654",
	"./1inch.svg": "7892",
	"./2give.svg": "0d29",
	"./aave.svg": "5214",
	"./abt.svg": "2d48",
	"./act.svg": "07ae",
	"./actn.svg": "cac8",
	"./ada.svg": "41c8",
	"./add.svg": "85ae",
	"./adx.svg": "7bb2",
	"./ae.svg": "7a66",
	"./aeon.svg": "3cf3",
	"./aeur.svg": "2db8",
	"./agi.svg": "9bd0",
	"./agrs.svg": "80f3",
	"./aion.svg": "79d7",
	"./algo.svg": "e0ed",
	"./amb.svg": "c8df",
	"./amp.svg": "1187",
	"./ampl.svg": "2c99",
	"./ankr.svg": "5e9c",
	"./ant.svg": "5e8e",
	"./apex.svg": "9c9d",
	"./appc.svg": "19d9",
	"./ardr.svg": "a3ed",
	"./arg.svg": "c616",
	"./ark.svg": "c1c9",
	"./arn.svg": "0a71",
	"./arnx.svg": "ac0a",
	"./ary.svg": "78c3",
	"./ast.svg": "6c75",
	"./atm.svg": "28d4",
	"./atom.svg": "69c3",
	"./audr.svg": "5052",
	"./auto.svg": "6fbd",
	"./avax.svg": "9ebf",
	"./aywa.svg": "8e2e",
	"./bab.svg": "33af",
	"./bal.svg": "8d75",
	"./band.svg": "f333",
	"./bat.svg": "4821",
	"./bay.svg": "02f0",
	"./bcbc.svg": "5df1",
	"./bcc.svg": "e58d",
	"./bcd.svg": "fd32",
	"./bch.svg": "28fe",
	"./bcio.svg": "5a57",
	"./bcn.svg": "4e8d",
	"./bco.svg": "d0a5",
	"./bcpt.svg": "0242",
	"./bdl.svg": "c342",
	"./beam.svg": "0daf",
	"./bela.svg": "a0f8",
	"./bix.svg": "1a02",
	"./blcn.svg": "c646",
	"./blk.svg": "2e36",
	"./block.svg": "13bb",
	"./blz.svg": "a3d5",
	"./bnb.svg": "bd31",
	"./bnt.svg": "9a9e",
	"./bnty.svg": "4532",
	"./booty.svg": "8644",
	"./bos.svg": "1d9d",
	"./bpt.svg": "79fe",
	"./bq.svg": "0759",
	"./brd.svg": "dba4",
	"./bsd.svg": "fc56",
	"./bsv.svg": "18be",
	"./btc.svg": "bd91",
	"./btcb.svg": "10c4",
	"./btcd.svg": "15d6",
	"./btch.svg": "dd51",
	"./btcp.svg": "c065",
	"./btcz.svg": "292e",
	"./btdx.svg": "2a933",
	"./btg.svg": "0157",
	"./btm.svg": "0da3",
	"./bts.svg": "934a",
	"./btt.svg": "91a3",
	"./btx.svg": "c771",
	"./burst.svg": "5d69",
	"./busd.svg": "33be",
	"./bze.svg": "0425",
	"./call.svg": "72c1",
	"./cc.svg": "7c39",
	"./cdn.svg": "9419",
	"./cdt.svg": "2f56",
	"./cenz.svg": "860e",
	"./chain.svg": "b9ad",
	"./chat.svg": "f160",
	"./chips.svg": "2b0a",
	"./chsb.svg": "d2db",
	"./chz.svg": "d4fc",
	"./cix.svg": "886b",
	"./clam.svg": "f723",
	"./cloak.svg": "9d79",
	"./cmm.svg": "3fdd",
	"./cmt.svg": "b6c1",
	"./cnd.svg": "4621",
	"./cnx.svg": "081d",
	"./cny.svg": "83b3",
	"./cob.svg": "ca9a",
	"./colx.svg": "136d",
	"./comp.svg": "47c9",
	"./coqui.svg": "cb93",
	"./cred.svg": "378a",
	"./crpt.svg": "fdaa",
	"./crv.svg": "eee0",
	"./crw.svg": "5397",
	"./cs.svg": "f5d4",
	"./ctr.svg": "d5a6",
	"./ctxc.svg": "a704",
	"./cvc.svg": "513e",
	"./d.svg": "cf02",
	"./dai.svg": "2f25",
	"./dash.svg": "4ee2",
	"./dat.svg": "65d9",
	"./data.svg": "245f",
	"./dbc.svg": "a18d",
	"./dcn.svg": "5a39",
	"./dcr.svg": "88c8",
	"./deez.svg": "402e",
	"./dent.svg": "b9d0",
	"./dew.svg": "d809",
	"./dgb.svg": "1801",
	"./dgd.svg": "2df5",
	"./dlt.svg": "a265",
	"./dnt.svg": "b1bc",
	"./dock.svg": "a055",
	"./doge.svg": "b977",
	"./dot.svg": "4337",
	"./drgn.svg": "97a0",
	"./drop.svg": "16d7",
	"./dta.svg": "75ed",
	"./dth.svg": "f128",
	"./dtr.svg": "09d1",
	"./ebst.svg": "f926",
	"./eca.svg": "a100",
	"./edg.svg": "5c96",
	"./edo.svg": "f08a",
	"./edoge.svg": "37af",
	"./egld.svg": "a50f",
	"./ela.svg": "5ea0",
	"./elec.svg": "ed15",
	"./elf.svg": "a329",
	"./elix.svg": "6c30",
	"./ella.svg": "8306",
	"./emb.svg": "89e0",
	"./emc.svg": "5c62",
	"./emc2.svg": "bbf9",
	"./eng.svg": "c4ef",
	"./enj.svg": "5a45",
	"./entrp.svg": "1456",
	"./eon.svg": "a867",
	"./eop.svg": "f266",
	"./eos.svg": "29212",
	"./eqli.svg": "53fd",
	"./equa.svg": "e07a",
	"./etc.svg": "9ac5",
	"./eth.svg": "84a3",
	"./ethos.svg": "fc53",
	"./etn.svg": "968a",
	"./etp.svg": "a84d",
	"./eur.svg": "d55c",
	"./evx.svg": "3204",
	"./exmo.svg": "1f5f",
	"./exp.svg": "da0c",
	"./fair.svg": "1b4b",
	"./fct.svg": "5a36",
	"./fil.svg": "eccb",
	"./fjc.svg": "8c8e",
	"./fldc.svg": "06b0",
	"./flo.svg": "7eb9",
	"./flux.svg": "2d59",
	"./fsn.svg": "971e",
	"./ftc.svg": "a61e",
	"./ftm.svg": "0031",
	"./fuel.svg": "e2b5",
	"./fun.svg": "ff49",
	"./game.svg": "ff44",
	"./gas.svg": "40f6",
	"./gbp.svg": "d72d",
	"./gbx.svg": "1402",
	"./gbyte.svg": "ab4b",
	"./generic.svg": "4a82",
	"./gin.svg": "3907",
	"./glxt.svg": "02cd",
	"./gmr.svg": "1613",
	"./gno.svg": "218f",
	"./gnt.svg": "0673",
	"./gold.svg": "9e6c",
	"./grc.svg": "a997",
	"./grin.svg": "d799",
	"./grs.svg": "aa5e",
	"./grt.svg": "4fa6",
	"./gsc.svg": "20aa",
	"./gto.svg": "26c9",
	"./gup.svg": "9047",
	"./gusd.svg": "3645",
	"./gvt.svg": "224f",
	"./gxs.svg": "4334",
	"./gzr.svg": "925a",
	"./hbar.svg": "c8bb",
	"./hight.svg": "0cf7",
	"./hns.svg": "5cb1",
	"./hodl.svg": "84e6",
	"./hot.svg": "87ef",
	"./hpb.svg": "03f1",
	"./hsr.svg": "87ba",
	"./ht.svg": "ec63",
	"./html.svg": "1eef",
	"./huc.svg": "1ec0",
	"./husd.svg": "66f4",
	"./hush.svg": "82a7",
	"./icn.svg": "917d",
	"./icp.svg": "2675",
	"./icx.svg": "d0cb",
	"./ignis.svg": "dea9",
	"./ilk.svg": "1567",
	"./ink.svg": "807e",
	"./ins.svg": "085d",
	"./ion.svg": "31e7",
	"./iop.svg": "0a6c",
	"./iost.svg": "dd46",
	"./iota.svg": "7ce6",
	"./iotx.svg": "3627",
	"./iq.svg": "d719",
	"./itc.svg": "b512",
	"./jnt.svg": "9c9b",
	"./jpy.svg": "53f9",
	"./jst.svg": "9e9f",
	"./kcs.svg": "16ba",
	"./kin.svg": "5429",
	"./klown.svg": "56b1",
	"./kmd.svg": "22d6",
	"./knc.svg": "0f3b",
	"./krb.svg": "814d",
	"./ksm.svg": "66fd",
	"./lbc.svg": "842c",
	"./lend.svg": "46d7",
	"./leo.svg": "ccdf",
	"./link.svg": "6e49",
	"./lkk.svg": "eeaf",
	"./loom.svg": "7cad",
	"./lpt.svg": "847a",
	"./lrc.svg": "e3b3",
	"./lsk.svg": "5e1f",
	"./ltc.svg": "eb8c",
	"./lun.svg": "6de1",
	"./luna.svg": "aa37",
	"./maid.svg": "ba8d",
	"./mana.svg": "4224",
	"./matic.svg": "b148",
	"./max.svg": "c06b",
	"./mcap.svg": "754f",
	"./mco.svg": "b44c",
	"./mda.svg": "7561",
	"./mds.svg": "f1ce",
	"./mdt.svg": "7e2d",
	"./med.svg": "b1cc",
	"./meetone.svg": "5f73",
	"./mft.svg": "c19c",
	"./miota.svg": "58fd",
	"./mith.svg": "92bc",
	"./mkr.svg": "7118b",
	"./mln.svg": "2c2d",
	"./mnx.svg": "77d8",
	"./mnz.svg": "a655",
	"./moac.svg": "cb4f",
	"./mod.svg": "f1f2",
	"./mona.svg": "1d22",
	"./msr.svg": "5c26",
	"./mth.svg": "b0ba",
	"./mtl.svg": "1bd9",
	"./music.svg": "828a",
	"./mzc.svg": "dfd2",
	"./nano.svg": "80c1",
	"./nas.svg": "6fb3",
	"./nav.svg": "d66f",
	"./ncash.svg": "f0f2",
	"./ndz.svg": "a802",
	"./near.svg": "c947",
	"./nebl.svg": "6299",
	"./neo.svg": "83b4",
	"./neos.svg": "b31d",
	"./neu.svg": "09f8",
	"./nexo.svg": "9120",
	"./ngc.svg": "2f69",
	"./nio.svg": "a153",
	"./nkn.svg": "5e23",
	"./nlc2.svg": "212d",
	"./nlg.svg": "47a1",
	"./nmc.svg": "a793",
	"./nmr.svg": "15674",
	"./npxs.svg": "089c",
	"./ntbc.svg": "0aee",
	"./nuls.svg": "d83e",
	"./nxs.svg": "52ef",
	"./nxt.svg": "f10b",
	"./oax.svg": "97f0",
	"./ok.svg": "3fff",
	"./omg.svg": "66ff",
	"./omni.svg": "033c",
	"./one.svg": "7da9",
	"./ong.svg": "bd3b",
	"./ont.svg": "7b45",
	"./oot.svg": "22e7",
	"./ost.svg": "9a0e",
	"./ox.svg": "fc5d",
	"./oxt.svg": "1ed8",
	"./part.svg": "84f4",
	"./pasc.svg": "34c5",
	"./pasl.svg": "3499",
	"./pax.svg": "4cb8",
	"./paxg.svg": "a171",
	"./pay.svg": "1c15",
	"./payx.svg": "a9f8",
	"./pink.svg": "7345",
	"./pirl.svg": "e0a1",
	"./pivx.svg": "30a6",
	"./plr.svg": "ae6e",
	"./poa.svg": "514b",
	"./poe.svg": "c9ca",
	"./polis.svg": "ad8c",
	"./poly.svg": "4e14",
	"./pot.svg": "d983",
	"./powr.svg": "7201",
	"./ppc.svg": "99fb",
	"./ppp.svg": "d589",
	"./ppt.svg": "fcca",
	"./pre.svg": "20c5",
	"./prl.svg": "d50f",
	"./pungo.svg": "e22e",
	"./pura.svg": "0c2a",
	"./qash.svg": "c105",
	"./qiwi.svg": "9d7d",
	"./qlc.svg": "0d4c",
	"./qrl.svg": "1180",
	"./qsp.svg": "eb7c",
	"./qtum.svg": "8f36",
	"./r.svg": "1b04",
	"./rads.svg": "b827",
	"./rap.svg": "966f",
	"./rcn.svg": "882b",
	"./rdd.svg": "be46",
	"./rdn.svg": "53ab",
	"./ren.svg": "d2bd",
	"./rep.svg": "408f",
	"./repv2.svg": "8a19",
	"./req.svg": "f7b7",
	"./rhoc.svg": "bf82",
	"./ric.svg": "86f6",
	"./rise.svg": "caf2",
	"./rlc.svg": "5977",
	"./rpx.svg": "1655",
	"./rsr.svg": "5b05",
	"./rub.svg": "f7ef",
	"./rvn.svg": "3e0d",
	"./ryo.svg": "0dfc",
	"./safe.svg": "6556",
	"./safemoon.svg": "04ec",
	"./sai.svg": "43c8",
	"./salt.svg": "9647",
	"./san.svg": "a8bc",
	"./sand.svg": "0399",
	"./sbd.svg": "ed2d",
	"./sberbank.svg": "a664",
	"./sc.svg": "9850",
	"./shift.svg": "568e",
	"./sib.svg": "f7f2",
	"./sin.svg": "38b7",
	"./skl.svg": "4a7a",
	"./sky.svg": "be68",
	"./slr.svg": "edf7",
	"./sls.svg": "6032",
	"./smart.svg": "065a",
	"./sngls.svg": "4ca2",
	"./snm.svg": "cc3e",
	"./snt.svg": "ec0e",
	"./snx.svg": "69f0",
	"./soc.svg": "1a2e",
	"./sol.svg": "0c6f",
	"./spacehbit.svg": "072f",
	"./spank.svg": "333b",
	"./sphtx.svg": "7292",
	"./srn.svg": "c7cf",
	"./stak.svg": "7710",
	"./start.svg": "67e4",
	"./steem.svg": "d2ee",
	"./storj.svg": "c3bc",
	"./storm.svg": "cc91",
	"./stox.svg": "c484",
	"./stq.svg": "38e3",
	"./strat.svg": "5d24",
	"./stx.svg": "b0cf",
	"./sub.svg": "6ce6",
	"./sumo.svg": "e0ea",
	"./sun.svg": "3ef9",
	"./sushi.svg": "c88b",
	"./sys.svg": "2706",
	"./taas.svg": "231b",
	"./tau.svg": "58ba",
	"./tbx.svg": "9233",
	"./tel.svg": "f1ee",
	"./ten.svg": "0a2e",
	"./tern.svg": "e952",
	"./tgch.svg": "63b2",
	"./theta.svg": "b2bb",
	"./tix.svg": "f337",
	"./tkn.svg": "ca54",
	"./tks.svg": "7025",
	"./tnb.svg": "ef19",
	"./tnc.svg": "da6e",
	"./tnt.svg": "2214",
	"./tomo.svg": "61ba",
	"./tpay.svg": "6d96",
	"./trig.svg": "2e95",
	"./trtl.svg": "da4c",
	"./trx.svg": "ae6b",
	"./tusd.svg": "5bae",
	"./tzc.svg": "645f",
	"./ubq.svg": "cc49",
	"./uma.svg": "cfe9",
	"./uni.svg": "da13",
	"./unity.svg": "e9dd",
	"./usd.svg": "c688",
	"./usdc.svg": "0a20",
	"./usdt.svg": "c1974",
	"./utk.svg": "3b76",
	"./veri.svg": "137b",
	"./vet.svg": "c800",
	"./via.svg": "0d64",
	"./vib.svg": "e9ee",
	"./vibe.svg": "37d3",
	"./vivo.svg": "fe06",
	"./vrc.svg": "0bfc",
	"./vrsc.svg": "8c42",
	"./vtc.svg": "d210",
	"./vtho.svg": "1598",
	"./wabi.svg": "b85f",
	"./wan.svg": "0831",
	"./waves.svg": "3010",
	"./wax.svg": "54de",
	"./wbnb.svg": "09bd",
	"./wbtc.svg": "c4bc",
	"./weth.svg": "5e31",
	"./wgr.svg": "4f5c1",
	"./wicc.svg": "c828",
	"./wings.svg": "4b54",
	"./wpr.svg": "0d4c6",
	"./wtc.svg": "de59",
	"./x.svg": "fd03",
	"./xas.svg": "fb58",
	"./xbc.svg": "6f3e",
	"./xbp.svg": "08b3",
	"./xby.svg": "1c4b",
	"./xcp.svg": "053b",
	"./xdn.svg": "9381",
	"./xem.svg": "7a35",
	"./xin.svg": "174b",
	"./xlm.svg": "7656",
	"./xmcc.svg": "4aff",
	"./xmg.svg": "ee99",
	"./xmo.svg": "89a8",
	"./xmr.svg": "f231",
	"./xmy.svg": "0ccc",
	"./xp.svg": "bef0",
	"./xpa.svg": "ea00",
	"./xpm.svg": "140f",
	"./xpr.svg": "6573",
	"./xrp.svg": "a8f1",
	"./xsg.svg": "f17d",
	"./xtz.svg": "1820",
	"./xuc.svg": "1f43",
	"./xvc.svg": "2a9d",
	"./xvg.svg": "1ae0",
	"./xzc.svg": "3d9c",
	"./yfi.svg": "67e6",
	"./yfii.svg": "c7b8",
	"./yoyow.svg": "8355",
	"./zcl.svg": "c3a5",
	"./zec.svg": "1acc",
	"./zel.svg": "4d8a",
	"./zen.svg": "3fce",
	"./zest.svg": "e891",
	"./zil.svg": "b182",
	"./zilla.svg": "53bf",
	"./zrx.svg": "d3ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5295";